import { CommonModule } from "@angular/common";
import { Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "jni-android-app",
  templateUrl: "./android-app.component.html",
  styleUrls: ["./android-app.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule],
})
export class AndroidAppComponent {
  constructor(private router: Router) {}

  backNavigation() {
    this.router.navigate(["sale-mobile-app"]);
  }
}
